import Swiper from 'swiper';
import nextSvg from '../../../assets/svg/arrow-right-green.svg';
import prevSvg from '../../../assets/svg/arrow-left.svg';

export default Array.from(document.querySelectorAll('.media-slider > .media-slider__slides')).map((slider) => {
	const wrapper = slider.querySelector('.media-slider__slides-wrap');
	const slides = wrapper.querySelectorAll('.media-slider__slide');

	if (!wrapper || !slides) {
		return;
	}

	slider.classList.add('swiper-container');
	wrapper.classList.add('swiper-wrapper');
	// wrapper.classList.add('swiper-counter');
	slides.forEach(slide => slide.classList.add('swiper-slide'));

	slider.insertAdjacentHTML(
		'beforeend',
		`
		<div id="tabsSliderDropdown" class="tabs__nav">
			<h6 class="">Additional Links</h6>
			<nav id="dropdownNav" class="media-slider__pagination">
			</nav>
		</div>`
		
	);

	var names = [];
				var elementList = document.querySelectorAll('.swiper-slide  .slider__slides  .slider__card-kicker');
				elementList.forEach(elementList => {
					console.log('elementList: ', elementList.innerText);
					names.push(elementList.innerText);
				  });
	return new Swiper(slider, {
		direction: 'horizontal',
		autoHeight: slider.dataset.autoHeight ? true : false,
		speed: 600,
		spaceBetween: 0,
		slidesPerView: 1,
		loop: false,

		breakpoints: {
			768: {
				spaceBetween: 10,
			}
		},
		pagination: {
			el: ".media-slider__pagination",
			clickable: true,
			renderBullet: function (index, className) {
				//return '<span class="' + className + '">' + (names[index]) + '</span>';
				return '<div class="pagination__text ' + className + ' "><span class="pagination-kicker ">' + (names[index])+ '</span></div></div>';
			  },	  
		},
		navigation: {
			prevEl: 'tabs__nav .swiper-button-prev',
			nextEl: 'tabs__nav .swiper-button-next',
		},

	});
});
